<template>
    <header class="nav-bar flex relative">
        <div class="flex items-center absolute">
            <img
                v-show="leftArrow"
                class="back"
                src="@/assets/img/icon_back.png"
                alt="back"
                @click="$emit('on-back')"
            />
        </div>
        <div :class="['content', { ellipsis }]">{{ title }}</div>
        <div class="flex items-center absolute">
            <slot name="right" />
        </div>
    </header>
</template>

<script>
export default {
    name: 'TheHeading',
    props: {
        title: {
            type: String,
            default: '',
        },
        ellipsis: {
            type: Boolean,
            default: true,
        },
        leftArrow: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
header {
    padding: 20px 18px 0;
    line-height: 22px;
    text-align: center;
    background-color: #fff;
}

img.back {
    width: 18px;
    height: 18px;
}

.content {
    margin: 0 auto;
    font-size: 16px;
    font-weight: 500;
    color: var(--g-text-title-color);
    max-width: 60%;
}
</style>
